module.exports = __webpack_public_path__ + "assets/a6828d71dbe0ac40e9683292e99b511d.png";